import { createPortal } from "react-dom"
import { toast } from "react-toastify"
import classNames from "classnames"

import { usePostVendorAlertFreezeMutation } from "store/api/adminApi"
import { usePostAlertFreezeMutation } from "store/api/alertsApi"
import { ApiTypes } from "types"
import styles from "assets/scss/index.module.scss"
import { ReactComponent as IconFreeze } from "assets/svg/modal-icon-freeze.svg"

import getErrorMessage from "utils/getErrorMessage"
import { ModalLayout } from "layouts/ModalLayout"

interface Props {
  isVendor?: boolean
  onCancel: () => void
  onSuccess: () => void
  currentAlerts: ApiTypes.Model.Alert[]
}

export const AlertsFreezeModal = ({ isVendor, onCancel, onSuccess, currentAlerts }: Props) => {
  const [triggerAlertFreeze, { isLoading }] = isVendor
    ? usePostVendorAlertFreezeMutation()
    : usePostAlertFreezeMutation()

  const onSubmit = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault()

    try {
      const res = await triggerAlertFreeze(currentAlerts.map(alert => alert.id))
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
      } else {
        toast.success("Alert has been successfully frozen!")
        onSuccess()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {createPortal(
        <ModalLayout width="450px" isFetching={isLoading} onConfirm={onSubmit} onCancel={onCancel}>
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconFreeze />
            <h3 className={styles.modalTitle}>Freeze</h3>
            <div className={styles.modalMessage}>
              By freezing the alert, it will no longer be received. Are you sure you want to proceed with freezing this
              alert?
            </div>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
